function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M93.415,12.767a6.177,6.177,0,0,0,4.514-1.87A6.176,6.176,0,0,0,99.8,6.383a6.177,6.177,0,0,0-1.87-4.513,6.382,6.382,0,0,0-9.027,0,6.177,6.177,0,0,0-1.87,4.513A6.176,6.176,0,0,0,88.9,10.9,6.178,6.178,0,0,0,93.415,12.767Zm0,0",
  transform: "translate(-82.526)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.058,254.894a15.767,15.767,0,0,0-.215-1.675,13.194,13.194,0,0,0-.412-1.684,8.317,8.317,0,0,0-.692-1.57,5.925,5.925,0,0,0-1.044-1.36,4.6,4.6,0,0,0-1.5-.942,5.182,5.182,0,0,0-1.914-.346,1.943,1.943,0,0,0-1.038.44c-.311.2-.675.437-1.081.7a6.193,6.193,0,0,1-1.4.616,5.43,5.43,0,0,1-3.421,0,6.176,6.176,0,0,1-1.4-.616c-.4-.257-.766-.492-1.082-.7a1.94,1.94,0,0,0-1.037-.44,5.175,5.175,0,0,0-1.914.347,4.6,4.6,0,0,0-1.5.942,5.927,5.927,0,0,0-1.043,1.36,8.333,8.333,0,0,0-.692,1.571,13.226,13.226,0,0,0-.412,1.684,15.712,15.712,0,0,0-.215,1.675C.018,255.4,0,255.928,0,256.46a4.4,4.4,0,0,0,1.307,3.329,4.7,4.7,0,0,0,3.368,1.229H17.437a4.7,4.7,0,0,0,3.368-1.229,4.4,4.4,0,0,0,1.307-3.33C22.112,255.926,22.094,255.4,22.058,254.894Zm0,0",
  transform: "translate(0 -234.514)"
});

var SvgProfileIcon = function SvgProfileIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.112,
    height: 26.504,
    viewBox: "0 0 22.112 26.504",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfileIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/profileIcon.22ec6751.svg";
export { ForwardRef as ReactComponent };